"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeCollectorType = void 0;
/**
 * Where should the field be collected
 *
 * This is used as a hint to field collectors to stop them collecting
 * data in the field when its best collected in the back office.
 */
exports.IkeCollectorType = {
    /**
     * No preference on where to be collected.
     * @default
     */
    ALL: 'all',
    /** Prefer to be collected in the field */
    FIELD: 'field',
    /** Prefer to be collected in the office */
    OFFICE: 'office',
};
//# sourceMappingURL=collector.js.map